import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Phone, Mail } from 'lucide-react';
import SEO from '../components/SEO';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="À propos | Pam Immobilier - Pamela Moll, courtière"
        description="Découvrez Pamela Moll, courtière immobilière passionnée. Un accompagnement personnalisé pour vos projets d'achat ou de vente en Suisse romande."
      />
      <Header />
      <main>
        {/* Hero Section - Clean gradient banner */}
        <section className="relative bg-gradient-to-br from-[#8B2942] via-[#A13350] to-[#722338] overflow-hidden mt-32" style={{ height: '120px' }}>
          <div className="absolute inset-0 flex items-center z-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
              <h1 className="text-2xl md:text-3xl font-bold text-white">
                Présentation
              </h1>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Mon parcours avec caricature */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-16">
              {/* Caricature with bubbles */}
              <div className="flex justify-center relative">
                {/* Animated decorative bubbles - same as homepage */}
                <div className="absolute top-20 -left-4 w-24 h-24 bg-[#8B2942]/25 rounded-full -z-0 animate-float-slow" />
                <div className="absolute bottom-20 right-10 w-32 h-32 bg-[#A13350]/15 rounded-full -z-0 animate-float-medium" />
                <div className="absolute top-1/2 -right-6 w-16 h-16 bg-[#722338]/20 rounded-full -z-0 animate-float-fast" />
                <div className="absolute top-40 right-20 w-12 h-12 bg-[#9E3A5C]/30 rounded-full -z-0 animate-float-reverse" />
                <img 
                  src="https://customer-assets.emergentagent.com/job_14bd1402-02f4-4dac-83c7-ac89ea1f2296/artifacts/bpy80ko8_image.png"
                  alt="Pamela - Agent immobilier"
                  className="w-80 h-auto object-contain relative z-10 drop-shadow-2xl transition-transform duration-500 hover:scale-105"
                />
              </div>

              {/* Text content */}
              <div className="prose prose-lg max-w-none">
                <div className="space-y-6 text-slate-600 leading-relaxed">
                  <p>
                    À l'origine, je cherchais simplement la maison de mes rêves.
                    Au fil des visites et des échanges, l'immobilier s'est imposé comme une évidence.
                  </p>
                  <p>
                    Pour exercer ce métier avec sérieux et professionnalisme, je me suis formée auprès de l'USPI (Union suisse des professionnels de l'immobilier).
                  </p>
                  <p>
                    Aujourd'hui, j'ai à cœur de vous accompagner dans ces moments importants de la vie, lorsque naissent de beaux projets : changer de lieu de vie, vendre pour mieux avancer.
                  </p>
                  <p>
                    Chaque bien est suivi avec la même attention et la même implication.
                    La disponibilité et la proximité font partie intégrante de l'accompagnement proposé par Pam Immobilier.
                  </p>
                  <p className="font-semibold text-[#8B2942]">
                    Merci à tous mes clients pour leur confiance et les projets que vous me confiez.
                  </p>
                </div>
              </div>
            </div>

            {/* Vous souhaitez vendre */}
            <div className="bg-gray-50 p-8 md:p-16 rounded-2xl mb-16 text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-[#8B2942] mb-6 uppercase">
                Vous souhaitez vendre
              </h2>
              <p className="text-lg md:text-xl text-slate-600 mb-4">
                votre maison, votre appartement ou un terrain ?
              </p>
              <p className="text-xl md:text-2xl text-slate-700 font-semibold mb-10">
                Avec Pam, ce sera plus simple. Et plus sympa.
              </p>
              
              <div className="space-y-6 text-slate-600 leading-relaxed mb-10 max-w-3xl mx-auto">
                <p>
                  Pour vendre, n'hésitez pas à me contacter.
                  Je me déplace volontiers pour une estimation personnalisée de votre bien sans engagement.
                </p>
                <p>
                  Chez PAM, votre bien bénéficie d'une large visibilité, grâce à mon réseau interprofessionnel et à une diffusion ciblée sur les principales plateformes actives en Suisse romande.
                </p>
              </div>

              {/* Contact Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button asChild size="lg" className="bg-[#8B2942] hover:bg-[#6d2033] text-lg px-8 py-6">
                  <a href="tel:+41791337898" className="flex items-center gap-2">
                    <Phone className="w-5 h-5" />
                    Me contacter
                  </a>
                </Button>
                <Button asChild size="lg" variant="outline" className="border-2 border-[#8B2942] text-[#8B2942] hover:bg-[#8B2942] hover:text-white text-lg px-8 py-6">
                  <Link to="/contact" className="flex items-center gap-2">
                    <Mail className="w-5 h-5" />
                    Envoyer un message
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;